<template>
  <page-section class="retrospective">
    <div class="retrospective__grid">
      <a
        :href="item.href"
        v-for="item in items"
        :key="item.title"
        class="retrospective__item"
      >
        <div class="retrospective__image-container">
          <div
            v-if="!item.src || item.src === '' || item.src === null"
            class="retrospective__image retrospective__image--placeholder"
          ></div>
          <img
            v-else
            :src="item.src"
            :alt="item.title"
            class="retrospective__image"
          />
          <div v-if="item.type">
            <span class="retrospective__type_label">{{ item.type }}</span>
          </div>
        </div>
        <div class="retrospective__content">
          <div class="retrospective__date">
            {{ item.date || "&nbsp;" }}
            <span v-if="item.date2"> — {{ item.date2 }} </span>
          </div>
          <h2 class="retrospective__title">
            <span>{{ item.title }}</span>
            <Icon type="arrow-right" class="latest_news__item__arrow" />
          </h2>
        </div>
      </a>
    </div>
  </page-section>
</template>
<script lang="js">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    items: {
      type: Array,
      required: true,
    }
  },
});
</script>

<style scoped lang="scss">
.retrospective {
  &__grid {
    grid-column: 6 / -6;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1.5rem;
    row-gap: 2.5rem;
    margin-bottom: 2rem;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 1.5rem;
      row-gap: 2.5rem;
    }
  }
  &__type {
    &_label {
      background: #ffce32;
      padding: 0.2em 0.5em;
      font-size: 0.8em;
      position: absolute;
      bottom: 1em;
      right: 1em;
    }
  }

  &__item {
    display: block;
    text-decoration: none;
    color: inherit;

    &:hover {
      .retrospective__image-container {
        transform: translateY(-0.2em);
      }
      // box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    }
  }

  &__image-container {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    transition: 0.2s ease-in-out;
    background-color: #f5f5f5;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
    border-radius: 0.4em;
    // .retrospective__item:hover & {
    //   transform: scale(1.05);
    // }

    &--placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
      color: #999;
      // border: 2px solid #ccc;
    }
  }

  &__content {
    padding: 0.5rem 0;
  }

  &__date {
    @include typo--latestnews-date;
  }

  &__title {
    @include typo--latestnews-title;
    display: flex;
    justify-content: space-between;
  }

  // Responsive adjustments
  @media (max-width: 1024px) {
    &__grid {
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }
  }

  @media (max-width: 640px) {
    &__grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 0.75rem;
    }

    &__title {
      font-size: 1rem;
    }
  }
}
</style>
